export default {
  props: {
    medicalRecordId: {
      type: String,
      required: true,
    },
    patient: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    triage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saving: false,
      removing: false,
      form: {},
    };
  },
  mounted() {
    this.form = {
      ...this.form,
      ...this.data.inputs,
      id: this.data.id,
    };
  },
  computed: {
    printUrl() {
      const recordId = this.medicalRecordId;
      return `/medical-records/${recordId}/exams/${this.data.id}/print`;
    },
  },
  methods: {
    async save() {
      this.saving = true;
      try {
        const recordId = this.medicalRecordId;
        await this.$http.put(`/medical-records/${recordId}/exams/${this.data.id}`, {
          inputs: this.form,
        });
        this.$toast.success('Exame salvo com sucesso');
        this.$emit('save');
      } catch (e) {
        this.$toast.error(e);
      }
      this.saving = false;
    },
    promptRemoval() {
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente excluir este exame?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: async (close) => {
              await this.remove();
              close();
            },
          },
        ],
      });
    },
    async remove() {
      this.removing = true;
      try {
        const recordId = this.medicalRecordId;
        await this.$http.delete(`/medical-records/${recordId}/exams/${this.data.id}`);
        this.$toast.success('Exame removido com sucesso');
        this.$emit('remove', this.data.id);
      } catch (e) {
        this.$toast.error(e);
      }
      this.removing = false;
    },
  },
};
